import formStyle from '@/styles/modules/form.module.scss';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import { useController } from 'react-hook-form';
import type { DeepMap, FieldError, FieldValues, UseControllerProps } from 'react-hook-form/dist/types';
import FormLabel from '../../form/FormLabel/FormLabel';
import FaIcon from '../../icon/FaIcon/FaIcon';
import styles from './FormFile.module.scss';

// ファイル形式の定数
const ACCEPTED_FILE_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/heic',
  'video/mp4',
  'video/quicktime',
  'video/x-msvideo',
  'video/hevc',
  'video/mp4; codecs=hevc',
  'video/hevc; codecs=hvc1',
  '.heic',
  '.hevc',
  '.mov',
  '.mp4',
].join(', ');

type Props<T extends FieldValues> = {
  label?: string;
  required?: boolean;
  accept?: string;
} & UseControllerProps<T>;

function FormFile<T extends FieldValues>({
  name,
  label,
  required = false,
  control,
  accept = ACCEPTED_FILE_TYPES,
}: Props<T>) {
  const {
    field,
    fieldState: { error },
  } = useController<T>({ name, control });

  return (
    <div className={formStyle.formComponentStyle}>
      {/* ラベル */}
      {label && <FormLabel>{label}</FormLabel>}
      {/* フィールドブロック */}
      <div className={error && formStyle.hasError}>
        <div className={styles.fieldWrapper}>
          <label>
            <div className={styles.fileSelector}>
              <div className={styles.iconStyle}>
                <FaIcon icon={faPaperclip} />
              </div>

              <p>添付画像を選択</p>
            </div>
            <input
              type='file'
              required={required}
              name={field.name}
              ref={field.ref}
              onBlur={field.onBlur}
              onChange={(e) => {
                const file = e.target.files?.[0];
                if (file) {
                  const maxSize = 1073741824; // 1GB in bytes

                  if (file.size <= maxSize) {
                    field.onChange(file);
                  } else {
                    e.target.value = '';
                    field.onChange(null);
                  }
                } else {
                  field.onChange(null);
                }
              }}
              className={styles.input}
              accept={accept}
            />
          </label>
          {field.value && <div className={styles.fileName}>{field.value.name}</div>}
        </div>
        {/* エラー */}
        {error && <p className={formStyle.validateErrors}>{(error as DeepMap<FieldValues, FieldError>).message}</p>}
      </div>
    </div>
  );
}
export default FormFile;
